import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import type { AdminArticleListItem } from "@/types/article";
import {
  usePublishArticle,
  useUnpublishArticle,
} from "@/hooks/use-articles";

interface PublishDialogProps {
  article: AdminArticleListItem;
  action: "publish" | "unpublish";
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PublishDialog({
  article,
  action,
  open,
  onOpenChange,
}: PublishDialogProps) {
  const publishMutation = usePublishArticle();
  const unpublishMutation = useUnpublishArticle();

  const isPublish = action === "publish";
  const mutation = isPublish ? publishMutation : unpublishMutation;
  const isPending = mutation.isPending;

  const handleConfirm = () => {
    mutation.mutate(article._id, {
      onSuccess: () => onOpenChange(false),
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {isPublish ? "아티클 발행" : "발행 취소"}
          </DialogTitle>
          <DialogDescription>
            {isPublish
              ? "이 아티클을 발행하면 사용자에게 공개됩니다."
              : "발행을 취소하면 사용자에게 더 이상 표시되지 않습니다."}
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border p-4 space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">제목</span>
            <span className="text-sm truncate max-w-[200px]">
              {article.title.ko}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">작성자</span>
            <span className="text-sm">{article.authorInfo.name.ko}</span>
          </div>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            취소
          </Button>
          <Button
            type="button"
            variant={isPublish ? "default" : "destructive"}
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending
              ? "처리 중..."
              : isPublish
                ? "발행 확인"
                : "발행 취소 확인"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
